import React from 'react';

import PropTypes from 'prop-types';

import css from './RequiredLabelRight.module.scss';

const RequiredLabelRight = ({ text }) => {
  return (
    <div className={css['RequiredLabelRight']}>
      <span>{text}</span>
      <span className={css['RequiredLabelRight-item']}>*</span>
    </div>
  );
};

RequiredLabelRight.propTypes = { text: PropTypes.string };

export default RequiredLabelRight;
